import { Avatar, Name, Email } from 'common/components/customer';

const CustomerDisplay = (props) => {
  const { customer } = props;
  return (
    <>
      <h3>Contact information</h3>

      <div className="c7-checkout__content__account">
        <Avatar customer={customer} />
        <div>
          <Name customer={customer} />
          <br />
          <Email customer={customer} />
        </div>
      </div>
    </>
  );
};
export default CustomerDisplay;
